import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/concrete-leads-colorado")!;

export const Route = createFileRoute("/learn/concrete-leads-colorado")({
  head: () => seoHead("/learn/concrete-leads-colorado", "How Colorado Concrete Contractors Get More Calls", "Project pages, Google Maps photos, and reviews that help Colorado concrete contractors get more patio and driveway calls.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
